import { CommonModule  } from '@angular/common';
import { NgModule} from '@angular/core';
import { RouterModule } from '@angular/router';  
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ng2-tooltip-directive';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ControlMessagesComponent } from '../../control-message.component';
import { ControlSelectMessagesComponent } from '../../control-select-message.component';
import { ControlFileMessagesComponent } from '../../control-file-message.component';
import { MatchHeightDirective } from '../../directive/match-height.directive';

import { ShowHidePasswordDirective } from '../../directive/showhide-password.directive';
import { HeaderComponent, 
	     FooterComponent,   
		 TestimonialComponent,  
		 LogoCarouselComponent,   
		 FeatureComponent, 
		 PaginationComponent,                       
		 ChangePasswordComponent,         
		 PopupComponent,
		 EmailVerifyComponent,
		 LoadingComponent,
		 SearchLoadingComponent, 
		 FileUploadComponent,
		 FileUploadsComponent,
		 FileUploadmultiComponent,
		 NotificationComponent} from './layout/index';                            
       
import { KeysPipe, SafeHtmlPipe, SafeUrlPipe, SearchFilterPipe, CommaSeperatedPricePipe, DisplayPricePipe, DateAgoPipe, ReplaceLineBreaks } from '../../_pipes/index'; 
import { CommonService } from './service/common.service';
import { LogoutDirective } from "../../directive/logout.directive";
import { Paypal } from '../../directive/paypal.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule, BsModalRef,BsModalService } from 'ngx-bootstrap/modal'; 
import { LaddaModule } from 'angular7-ladda';   
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';
import { AgmCoreModule } from '@agm/core';
import { environment } from '../../../environments/environment';     
import { NgxCaptchaModule } from 'ngx-captcha';
import { SignedImageDirective } from '../../directive/signed-image.directive';

@NgModule({    
	declarations: [HeaderComponent,      
		FooterComponent,      
		TestimonialComponent,     
		LogoCarouselComponent,    
		FeatureComponent,          
		PaginationComponent,     
		ControlMessagesComponent,    
		ControlSelectMessagesComponent, 
		ControlFileMessagesComponent,
		PopupComponent,   
		FileUploadComponent, 
		FileUploadsComponent, 
		FileUploadmultiComponent, 
		EmailVerifyComponent,
		LoadingComponent, 
		SearchLoadingComponent,  
		NotificationComponent, 
		ChangePasswordComponent, 
		MatchHeightDirective,   
		ShowHidePasswordDirective,
		LogoutDirective, 
		Paypal, 
		KeysPipe,
		CommaSeperatedPricePipe,
		SafeHtmlPipe,
		SafeUrlPipe,
		SearchFilterPipe,
		DisplayPricePipe, 
		DateAgoPipe,   
		ReplaceLineBreaks,
		SignedImageDirective
	],  
	imports: [ 
		CommonModule, 
		TranslateModule, 
		RouterModule, 
		TooltipModule,    
		FormsModule,  
		ReactiveFormsModule,
		NgxCaptchaModule,
		CarouselModule,  
		ModalModule.forRoot(),
		LaddaModule.forRoot({
			style: "expand-right",  
			spinnerColor: "OrangeRed"       
		}),  
		MalihuScrollbarModule.forRoot(),
		NgxSkeletonLoaderModule.forRoot({ animation: 'progress'}),
		AgmCoreModule.forRoot({
			apiKey: environment.GOOGLE_MAP_SITE_KEY,
			libraries: ['places']
		})           
	],    
	providers: [CommonService],  
	entryComponents: [PopupComponent], //Important!  
	exports: [    
		HeaderComponent,       
		FooterComponent, 
		TestimonialComponent,  
		LogoCarouselComponent,    
		FeatureComponent,    
		PaginationComponent,  
		ControlMessagesComponent,  
		ControlSelectMessagesComponent, 
		ControlFileMessagesComponent,    
		ChangePasswordComponent, 
		PopupComponent, 
		FileUploadComponent,
		FileUploadsComponent,
		FileUploadmultiComponent,
		EmailVerifyComponent,		
		LoadingComponent, 
		SearchLoadingComponent, 
		NotificationComponent,   
		TranslateModule,   
		ShowHidePasswordDirective,      
		TooltipModule,       
		LogoutDirective, 
		Paypal,
		ModalModule,      
		MatchHeightDirective,       
		KeysPipe, 
		CommaSeperatedPricePipe,     
		SafeHtmlPipe, 
		SafeUrlPipe,
		SearchFilterPipe,
		DisplayPricePipe,              
		DateAgoPipe,
		ReplaceLineBreaks,
		SignedImageDirective  
	]                     
})                  
export class  SharedModule { }        


                                               
 

